export const HOME = '/';
export const ABOUT_US = '/estate-main/about-us';
export const CONTACT_US = '/estate-main/contact-us';
export const MARKETPLACE = '/estate-main/marketplace';
